import WebsiteModal from "modal/WebsiteModal";
import {svg_include} from "../index";
import Gallery from "../Gallery";

export default class LabelModal extends WebsiteModal {
    constructor(labels, start = 1) {
        super();
        this.labels = labels;
        this.start = start;
    }

    buildModal() {
        this.$modal = (
            eotwJSXFactory('div', {className: "modal"}, [
                eotwJSXFactory('div', {className: "modal__bg js-close-modal"}),
                eotwJSXFactory('div', {className: "modal__box modal__box--label"}, [
                    eotwJSXFactory('div', {className: "modal__close js-close-modal"}),
                    eotwJSXFactory('div', {className: "gallery js-gallery"}, [
                        eotwJSXFactory('div', {className: "gallery__items js-gallery-wrap"}, [
                            this.labels.map((label, index) => {
                                let second_unit = label['height-or-length'] === true ? 'L' : 'H';
                                let measurements = label.width + label.width_unit + ' W x ' + label.Height + label.height_unit + ' ' + second_unit;
                                let diameter = label.diameter + label.diameter_unit + ' ' + label.diameter_location;

                                return (
                                    eotwJSXFactory('div', {className: "gallery__item " + (index === 0 ? 'gallery__item--active' : '')}, [
                                        eotwJSXFactory('div', {className: "labels"}, [
                                            eotwJSXFactory('div', {className: "labels__image"}, [
                                                eotwJSXFactory('div', {className: "image"}, [
                                                    eotwJSXFactory('picture', null, [
                                                        eotwJSXFactory('source', {media: "(max-width: 599px)", srcset: label.label_image['labels-image-phablet'][0]}),
                                                        eotwJSXFactory('img', {className: "bg-image bg-image--contain", src: label.label_image['labels-image-max'][0]})
                                                    ])
                                                ])
                                            ]),
                                            eotwJSXFactory('div', {className: "labels__text"}, [
                                                eotwJSXFactory('div', {className: "heading heading--sub-heading heading--primary"}, ["Labels"]),
                                                eotwJSXFactory('h2', {className: "heading heading--2", unsafeHtml: label.title.rendered}),
                                                eotwJSXFactory('p', null, [eotwJSXFactory('span', {className: "labels__title"}, ["Compatibility:"])]),
                                                eotwJSXFactory('table', {className: "banded-table"}, [
                                                    eotwJSXFactory('tr', null, [
                                                        eotwJSXFactory('th', null, ["M"]),
                                                        eotwJSXFactory('th', null, ["Xs"]),
                                                        eotwJSXFactory('th', null, ["Xtra"])
                                                    ]),
                                                    eotwJSXFactory('tr', null, [
                                                        eotwJSXFactory('td', null, [eotwJSXFactory('span', {class: (label.compatibility.indexOf('m') !== -1 ? 'tick' : 'cross')})]),
                                                        eotwJSXFactory('td', null, [eotwJSXFactory('span', {class: (label.compatibility.indexOf('xs') !== -1 ? 'tick' : 'cross')})]),
                                                        eotwJSXFactory('td', null, [eotwJSXFactory('span', {class: (label.compatibility.indexOf('xtra') !== -1 ? 'tick' : 'cross')})])
                                                    ])
                                                ]),
                                                eotwJSXFactory('p', null, [eotwJSXFactory('span', {className: "labels__title"}, ["Type:"])," ", (label.type !== null && label.type !== '') ? label.type : 'N/A']),
                                                eotwJSXFactory('p', null, [eotwJSXFactory('span', {className: "labels__title"}, ["Measurements:"])," ", measurements]),
                                                eotwJSXFactory('p', null, [eotwJSXFactory('span', {className: "labels__title"}, ["Diameter:"])," ", diameter]),
                                                eotwJSXFactory('p', null, [eotwJSXFactory('span', {className: "labels__title"}, ["Rolls per box:"])," ", (label.rolls_per_box !== null && label.rolls_per_box !== '') ? label.rolls_per_box : 'N/A']),
                                                eotwJSXFactory('p', null, [eotwJSXFactory('span', {className: "labels__title"}, ["Labels per roll:"])," ", (label.lables_per_roll !== null && label.lables_per_roll !== '') ? label.lables_per_roll : 'N/A'])
                                            ])
                                        ])
                                    ])
                                );
                            })
                        ]),
                        eotwJSXFactory('div', {class: "gallery__actions"}, [
                            eotwJSXFactory('button', {type: "button", class: "arrow-btn arrow-btn--no-bg arrow-btn--outside-container js-navigate", title: "Previous", 'data-direction': "backwards", unsafeHtml: svg_include('dropdown-arrow')}),
                            eotwJSXFactory('div', {class: "gallery__text"}, [eotwJSXFactory('span', {class: "js-current-slide"}, ["1"]),"/", this.labels.length]),
                            eotwJSXFactory('button', {type: "button", class: "arrow-btn arrow-btn--no-bg arrow-btn--next arrow-btn--outside-container js-navigate", title: "Next", 'data-direction': "forwards", unsafeHtml: svg_include('dropdown-arrow')})
                        ])
                    ])
                ])
            ])
        );

        let gallery = new Gallery(this.$modal, {
            itemClass: "gallery__item",
            pipClass: "pips__btn",
            navigateClass: "js-navigate",
            pipsClass: "js-pips",
            itemsClass: "js-gallery-wrap",
            itemActiveModifier: "active",
            animationDuration: 0,
        });

        gallery.showItem(this.start);

        gallery.on('transitionEnd', ({from, to, direction}) => {
            gallery.$gallery.find('.js-current-slide').text(to + 1);
        });
    }

    buildElement() {
        this.buildModal();
    }
}